import { useState, useEffect, useCallback } from 'react';

export default function useTheme(): { isDark: boolean; toggle: () => void } {
  const [isDark, setIsDark] = useState<boolean>(() => {
    return document.documentElement.classList.contains('dark');
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('esgt-theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('esgt-theme', 'light');
    }
  }, [isDark]);

  const toggle = useCallback(() => setIsDark(d => !d), []);

  return { isDark, toggle };
}
